import React, { useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import GenericEditModal from '../hosts/GenericEditModal';

interface DescriptionSectionProps {
    camp: any;
    setCamp: (camp: any) => void;
    canEdit: boolean;
}

const DescriptionSection: React.FC<DescriptionSectionProps> = ({
    camp,
    setCamp,
    canEdit,
}) => {
    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const [hoveredDescription, setHoveredDescription] = useState(false);
    const hasDescription = Boolean(camp?.campDescription?.trim());
    const aboutUsText = hasDescription
        ? camp.campDescription
        : 'We are still adding details for this camp. Check back soon to learn more about programs, activities, and what campers can expect.';

    return (
        <>
            <View style={{ flexDirection: 'column', width: '100%', marginTop: 30 }}>
                <Text style={{ fontSize: 20, fontWeight: '500', marginBottom: 20 }}>
                    About Us
                </Text>
                {canEdit ? (
                    <Pressable
                        onPress={() => setShowDescriptionModal(true)}
                        onHoverIn={() => setHoveredDescription(true)}
                        onHoverOut={() => setHoveredDescription(false)}
                        style={{
                            borderWidth: hoveredDescription ? 1 : 0,
                            borderColor: hoveredDescription ? '#007bff' : 'transparent',
                            borderRadius: 8,
                            padding: hoveredDescription ? 16 : 0,
                            minHeight: 150,
                            backgroundColor: hoveredDescription ? '#f8f9fa' : 'transparent',
                            position: 'relative',
                        }}
                    >
                        <View style={{
                            flexDirection: 'row',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}>
                            <Text style={{
                                fontSize: 16,
                                color: hasDescription ? (hoveredDescription ? '#666' : '#333') : '#6b7280',
                                fontStyle: hasDescription ? 'normal' : 'italic',
                            }}>
                                {aboutUsText}
                            </Text>
                            {hoveredDescription && (
                                <MaterialCommunityIcons
                                    name="pencil"
                                    size={16}
                                    color="#007bff"
                                    style={{
                                        marginLeft: 8,
                                        marginTop: 2,
                                    }}
                                />
                            )}
                        </View>
                    </Pressable>
                ) : (
                    <Text style={{
                        fontSize: 16,
                        color: hasDescription ? '#333' : '#6b7280',
                        fontStyle: hasDescription ? 'normal' : 'italic',
                    }}>
                        {aboutUsText}
                    </Text>
                )}
            </View>

            {showDescriptionModal && (
                <GenericEditModal
                    visible={showDescriptionModal}
                    onClose={() => setShowDescriptionModal(false)}
                    currentValue={camp.campDescription || ''}
                    onSave={(newDescription) => {
                        setCamp((prev) => ({ ...prev, campDescription: newDescription }));
                    }}
                    title="Edit Camp Description"
                    label="About Your Camp"
                    placeholder="Tell us about your camp! Describe the activities, facilities, and what makes your camp special..."
                    helperText="Describe what campers can expect, including activities, facilities, and unique features"
                    maxLength={1000}
                    multiline={true}
                    validation={(value) => {
                        const trimmedValue = value.trim();
                        if (!trimmedValue) {
                            return 'Camp description is required';
                        }
                        if (trimmedValue.length < 10) {
                            return 'Description must be at least 10 characters long';
                        }
                        if (trimmedValue.length > 1000) {
                            return 'Description cannot exceed 1000 characters';
                        }
                        return '';
                    }}
                />
            )}
        </>
    );
};

export default DescriptionSection;

